import { ICreateFornecedorBancoUseCase } from "../../../presentation/useCases/create/create_fornecedor_banco_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CreateFornecedorBancoUseCase
 */

export class CreateFornecedorBancoUseCase implements ICreateFornecedorBancoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async createFornecedorBanco(
    idFornecedor: number,
    tipoConta: number,
    banco: string,
    agencia: string,
    conta: string,
    contaDigito: string,
    operacao: string,
    favorecido: string,
    cpfCnpj: string,
    pix: string,
  ): Promise<void> {
    await this.repository.createFornecedorBanco(
      idFornecedor,
      tipoConta,
      banco,
      agencia,
      conta,
      contaDigito,
      operacao,
      favorecido,
      cpfCnpj,
      pix,
    );
  }
}
